import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { ActivityService } from './activity.service';

const service = new ActivityService();

export interface ActivityState {}

const ActivityStore: Module<ActivityState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async getActivities(context, { customerId, query }: { customerId: number; query: LocationQuery }) {
         const response = await service.getActivities(customerId, query);
         return response;
      },
   },
};

export default ActivityStore;
